import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/DeleteOutline';

import { deleteWatermark } from '@modules/editor';

function DeleteBtn({ idx }) {
    const dispatch = useDispatch();
    function handleDelete() {
        console.log('handleDelete', idx);
        dispatch(deleteWatermark(idx));
    }

    return (
        <div style={{ cursor: 'pointer' }} onClick={handleDelete}>
            <DeleteIcon />
        </div>
    );
}

export default DeleteBtn;
